<!-- Tag Layout -->
<div class="mb-4">
   <h4 class="sidebar-title mb-3"> Tags </h4>
</div>
<a href="javascript:void(0)" class="btn btn-pill btn-sm mx-1 mb-2 {{tag?.btnBgClass}}" *ngFor="let tag of tags"> {{tag?.value}}</a>
